import React from 'react';

const VideoSingleLIstLoading = () => {

    return (
        <div className='flex gap-3 px-2 py-4'>
            <div className='animate-pulse'>
                <div className='w-[15px] bg-gray-200  h-[15px] rounded-full'>

                </div>

            </div>
            <div className='w-full'>
                <div role="status" class="space-y-2.5 animate-pulse  w-full">
                    <div class="flex items-center w-full space-x-2">
                        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32"></div>
                        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-40"></div>
                        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
                    </div>
                    <div class="flex items-center w-full space-x-2 max-w-[200px]">
                        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
                        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
                        <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
                    </div>
                    <div class="flex pt-1 pb-4 items-center w-full space-x-2 max-w-[80px]">
                        <div class="h-1.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
                        <div class="h-1.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoSingleLIstLoading;